module.exports = {"dropDownPlaceholder":"Accedi senza un Adobe ID"}


//////////////////
// WEBPACK FOOTER
// ./src/components/SolutionsDropdown/__localization__/SolutionsDropdown/it_it.json
// module id = 930
// module chunks = 0